import { alpha, SvgIcon } from '@mui/material';
import { useTheme } from '@mui/system';

interface FileUploadSVGProps {
  isHighlighted: boolean;
}

export const FileUploadInteractiveSVGIcon = ({
  isHighlighted,
}: FileUploadSVGProps) => {
  const theme = useTheme();

  const fillColor = isHighlighted
    ? theme.palette.primary.main
    : alpha(theme.palette.text.primary, 0.3);

  const backgroundColor = theme.palette.background.default;

  return (
    <SvgIcon
      viewBox="0 0 184 191"
      sx={{
        fontSize: '184px',
        fill: fillColor,
        transition: 'all 0.2s ease-in-out',
        transform: isHighlighted ? 'translateY(-12px)' : 'translateY(0px)',
      }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M148.809 56.8097L111.779 19.7797C108.943 16.943 105.033 15.333 100.969 15.333H45.9993C37.566 15.333 30.7427 22.233 30.7427 30.6663L30.666 153.333C30.666 161.766 37.4893 168.666 45.9227 168.666H137.999C146.433 168.666 153.333 161.766 153.333 153.333V67.6963C153.333 63.633 151.723 59.723 148.809 56.8097ZM113.466 115H99.666V138C99.666 142.216 96.216 145.666 91.9994 145.666C87.7827 145.666 84.3327 142.216 84.3327 138V115H70.6094C67.1594 115 65.4727 110.86 67.926 108.483L89.3927 87.093C90.926 85.6363 93.3027 85.6363 94.836 87.093L116.226 108.483C118.526 110.86 116.839 115 113.466 115ZM107.333 68.9997C103.116 68.9997 99.666 65.5497 99.666 61.333V26.833L141.833 68.9997H107.333Z" />
      <rect
        x="28.9434"
        y="15.1611"
        width="126.801"
        height="175.041"
        fill="url(#paint0_linear_612_85749)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_612_85749"
          x1="92.3441"
          y1="174.008"
          x2="92.3441"
          y2="14.1611"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={isHighlighted ? '0.0' : '0.2'}
            stopColor={backgroundColor}
          />
          <stop offset="1" stopColor={backgroundColor} stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
